var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 125,
    viewBox: "0 0 125 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 58.5H61M64 66.5H125M64 73.5H125M64 80.5H125M64 87.5H125M64 94.5H125M64 101.5H125M64 108.5H125M64 115.5H125M64 122.5H125M66.5 61V0M58.5 125V64M51.5 125V64M44.5 125V64M37.5 125V64M30.5 125V64M23.5 125V64M16.5 125V64M9.5 125V64M2.5 125V64M73.5 61V0M80.5 61V0M87.5 61V0M94.5 61V0M101.5 61V0M108.5 61V0M115.5 61V0M122.5 61V0M0 51.5H61M0 44.5H61M0 37.5H61M0 30.5H61M0 23.5H61M0 16.5H61M0 9.5H61M0 2.5H61",
    stroke: "white",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.230d530a9621a08f088489a77e40a26b.svg";
export { ForwardRef as ReactComponent };